import { Capacitor } from "@capacitor/core";

export function getSignInLink(requestedURL: string, email: string, keepMeLogin: boolean): string {
  const { port, hostname, pathname } = window.location;

  const isDev = hostname === "localhost";
  const formattedPort = port !== "" ? `:${port}` : "";

  const appDomain = `http${isDev ? "" : "s"}://${hostname}${formattedPort}`;

  const prPrefix = pathname.match(/^\/pr-\d+/)?.at(0) ?? "";

  // Add /mobile prefix for Capacitor app so backend uses correct bundle IDs
  const mobilePrefix = Capacitor.isNativePlatform() ? "/mobile" : "";

  const searchParams = new URLSearchParams({
    requestedUrl: requestedURL,
    email,
    keepMeLogin: String(keepMeLogin),
  });

  return `${appDomain}${prPrefix}${mobilePrefix}/login/verify?${searchParams}`;
}
